/* eslint-disable prettier/prettier */
import { MyThunkResult } from 'store';

import { airportsRequest, airportsSuccessful, airportsError } from 'action-creators/airports';
import { AirportRequestResponse } from 'models/airport';
import { BySearchType } from 'reducers/airports';
import { getCurrentLanguage } from 'utils/generic';
import { getLanguageWithoutRegion } from 'utils/i18n';

import { axiosConfig, rappiServicesTravelSearchCities } from '../api';

const dispatchRequest = (dispatch, type: string) => dispatch(airportsRequest());

const dispatchSuccess = (dispatch, type: string | BySearchType, data: AirportRequestResponse) =>
  dispatch(airportsSuccessful({ ...data, type }));

const dispatchError = (dispatch, type: string, ex: any) => dispatch(airportsError(ex));

export const searchAirport =
  (text: string, type: string): MyThunkResult<Promise<void>> =>
  async (dispatch, getState) => {
    try {
      dispatchRequest(dispatch, type);
      const { country } = getState().i18n;
      const currentLanguage = country ? getLanguageWithoutRegion(getCurrentLanguage()) : 'ES';

      const { data } = await rappiServicesTravelSearchCities.get<AirportRequestResponse>('', {
        params: {
          query: text.sanitize(),
          lang: currentLanguage.toUpperCase(),
          countrycode: '',
          type: '',
        },
        ...axiosConfig,
      });

      dispatchSuccess(dispatch, type, data);
    } catch (ex) {
      dispatchError(dispatch, type, ex);
    }
  };
